import { FileMetadata } from "../types/FileMetadata";
import { apiRequest } from "./apiClient";

export const getPresignedUrl = async (preSignedUrl:string) => {
    try {
      // Request a pre-signed URL from the backend
      const response = await apiRequest(preSignedUrl);
      return response.url;

    } catch (error) {
      console.error('Unable to get Presigned Url:', error);
    }
  };

export const uploadToS3 = async (s3url:string,selectedFile:FileMetadata) => {
  console.log("Uploading to S3 URL:", s3url);
  console.log("Selected file:", selectedFile);
          await fetch(s3url, {
            method: 'PUT',
            headers: {
              'Content-Type': selectedFile.filetype,
            },
            body: selectedFile.file,
          });
    
}